import { render, staticRenderFns } from "./lossWeightQuestionnaire.vue?vue&type=template&id=4c2d90a7&scoped=true&"
import script from "./lossWeightQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./lossWeightQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./lossWeightQuestionnaire.vue?vue&type=style&index=0&id=4c2d90a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2d90a7",
  null
  
)

export default component.exports